import { createFileRoute } from '@tanstack/react-router';

import { BloodReportPanelsPage } from '@/pages/blood-report';

export const Route = createFileRoute('/blood-report/_role-guard/$id/_report/')({
  component: BloodReportPanelsPage,
});
